export type ScanPhase =
  | "initializing"
  | "searching"
  | "scraping"
  | "classifying"
  | "hostingLookup"
  | "visibility"
  | "regionalReachability"
  | "finalizing"
  | "scanning";

// Normalize a progress message into one of the canonical phases above.
export function phaseFromMessage(message: string): ScanPhase {
  const m = (message || "").toLowerCase();
  if (
    m.includes("search") ||
    m.includes("exa") ||
    m.includes("firecrawl") ||
    m.includes("brave")
  ) {
    return "searching";
  }
  if (m.includes("scrap")) {
    return "scraping";
  }
  if (m.includes("classif") || m.includes("llm") || m.includes("validat")) {
    return "classifying";
  }
  if (m.includes("hosting") || m.includes("lookup")) {
    return "hostingLookup";
  }
  if (m.includes("visibility")) {
    return "visibility";
  }
  if (m.includes("reachability") || m.includes("regional")) {
    return "regionalReachability";
  }
  if (m.includes("saving") || m.includes("domain analytics") || m.includes("finaliz")) {
    return "finalizing";
  }
  if (m.includes("init") || m.includes("start")) {
    return "initializing";
  }
  return "scanning";
}

